/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GiftconBrandDetailDto } from '../models/GiftconBrandDetailDto';
import type { PaginatedGiftconBrandListDto } from '../models/PaginatedGiftconBrandListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GiftconBrandsService {
  /**
   * 기프티콘 브랜드 목록 조회
   * @returns PaginatedGiftconBrandListDto
   * @throws ApiError
   */
  public static giftconBrandControllerFindAllWithPagination({
    page = 1,
    itemsPerPage = 30,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedGiftconBrandListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcon-brands',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 기프티콘 브랜드 상세 조회
   * @returns GiftconBrandDetailDto
   * @throws ApiError
   */
  public static giftconBrandControllerFindOneById({
    giftconBrandId,
  }: {
    giftconBrandId: number;
  }): CancelablePromise<GiftconBrandDetailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcon-brands/{giftconBrandId}',
      path: {
        giftconBrandId: giftconBrandId,
      },
    });
  }
}
